import { Injectable } from '@angular/core';
import { EnvironmentService } from '../core/services/environment.service';
import { StorageService } from '../core/services/storage.service';
import { HttpService } from '../core/services/http.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';

@Injectable()
export class AuthService {

  constructor(
    private envService: EnvironmentService,
    private storageService: StorageService,
    private httpService: HttpService,
    private router: Router
  ) {
  }

  public login() {

    // Get Current Store Consumer Key and Callback Url
    const storeConsumerKey = this.envService.getStore('consumerKey');
    const callbackUrl = this.envService.getStore('callbackUrl');

    // Set Query parameters for TID Login URL
    let idmUrl = this.envService.get('loginUrl');
    const scope = this.envService.getStore('applicationName');
    idmUrl += '?response_type=code';
    idmUrl += '&scope=openid ' + scope;
    idmUrl += '&client_id=' + storeConsumerKey;
    idmUrl += '&redirect_uri=' + callbackUrl;

    // Load TID Login page
    window.location.href = idmUrl;
  }

  public isUserLoggedIn(): boolean {
    // if access token present in local storage returns true
    const token = this.storageService.getLocalItem('access_token');
    return (token) ? true : false;
  }

  public logout(isSessionExpired?: boolean) {

    // Generate Logout Url
    let logoutPath = this.envService.get('logoutUrl');
    logoutPath += '?id_token_hint=' + this.storageService.getLocalItem("access_token");
    logoutPath += '&post_logout_redirect_uri=' + this.envService.get('landingUrl');
       
    if (isSessionExpired) {
      logoutPath += '&sessionExpired=true';
    }

    // Clear All session details
    this.storageService.clearAll();
    // Loading Logout URL
    window.open(logoutPath, '_self');
  }
}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/auth/auth.service.ts